/**
 * Use this util in mappers where the data could be undefined.
 * Undefined values could not be used serverside in JSON to render the page because undefined not a valid JSON value
 */
export const asValueOrNull = <T>(value: T | undefined): T | null => (typeof value !== 'undefined' ? value : null);
